import { useCancelChangesModal } from '@/creditflowresearch/ui/common/CancelChangesModal';
import useMySelection from '@/creditflowresearch/ui/common/hooks/useMySelection';
import { useFormPayloadContext } from '@/creditflowresearch/application/PortfolioMonitor/FormPayloadContext';
import useGetPositions from '@/creditflowresearch/ui/components/portfolioMonitor/PortfolioContent/common/useGetPositions';

const useConfirmDeletePositions = (fields) => {
  const confirmDeletePositionsModal = useCancelChangesModal();

  const selection = useMySelection((item: number) => item);
  const { setPayload } = useFormPayloadContext();
  const { listIndex } = useGetPositions();

  const deletePositionFromList = (rowIndex) => {
    fields.remove(rowIndex);

    setPayload((prevState) => {
      const updatedLists = prevState.lists.map((list, index) => {
        if (index === listIndex) {
          return {
            ...list,
            positions: list.positions.filter((_, positionIndex) => positionIndex !== rowIndex),
          };
        }
        return list;
      });

      return { ...prevState, lists: updatedLists };
    });
  };

  const handleDeletePosition = (index) => {
    selection.addRows([index]);
    confirmDeletePositionsModal.showCanceledModal();
  };

  const confirmDeletePosition = () => {
    confirmDeletePositionsModal.hideCanceledModal();
    deletePositionFromList(selection.collection[0]);
    selection.reset();
  };

  return {
    selection,
    confirmDeletePositionsModal,
    handleDeletePosition,
    confirmDeletePosition,
  };
};

export default useConfirmDeletePositions;
